import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import React, { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { focusCloseButton, reactModalProps } from '../modal';

export interface IFormIssuerRef {
    setModalOpen(value: boolean, html?: string, title?: string): void;
}

const FormIssuerModal = (props: any, ref: ForwardedRef<IFormIssuerRef>) => {
    const { t } = useTranslation();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [html, setHtml] = useState<string>('');
    const [title, setTitle] = useState<string>('');

    useEffect(() => {
        if (!modalIsOpen) {
            document.body.classList.remove('modal-open');
        } else {
            focusCloseButton();
        }
    }, [modalIsOpen]);

    useImperativeHandle(ref, () => {
        return {
            setModalOpen(value: boolean, html: string, title: string) {
                setModalIsOpen(value);
                setHtml(html);
                setTitle(title);
            },
        };
    });

    ReactModal.setAppElement('#root');
    return (
        <ReactModal
            aria-label={t('modal_issuer_container_aria_label', { ns: 'accessibility' })}
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            contentLabel={title}
            {...reactModalProps}
        >
            <button
                className="modal__close-icon"
                onClick={() => setModalIsOpen(false)}
                aria-label={t('modal_close_aria_label', { ns: 'accessibility' })}
                id="modal_close_button"
            >
                <span className="visuallyhidden">
                    {t('modal_close_aria_label', { ns: 'accessibility' })}
                </span>
                <span aria-hidden="true">×</span>
            </button>
            <div className="body-medium">
                <h2 className="header-1 modal-header">{title}</h2>
                <div className="modal-bottom-element" dangerouslySetInnerHTML={{ __html: html }} />
                <div className="modal-center-button-container">
                    <button
                        className="button button--primary modal-center-button"
                        onClick={() => setModalIsOpen(false)}
                    >
                        {t('form_modal_description_continue')}
                    </button>
                </div>
            </div>
        </ReactModal>
    );
};

export default forwardRef(FormIssuerModal);
